import * as Types from '../index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PaymentPhoneFragment = { __typename?: 'PhonesEntity', id: string, value: string, type: Types.PhoneType };

export type PaymentAddressFragment = { __typename?: 'AddressEntity', id: string, lineOne: string, lineTwo?: string | null, city: string, state: string, zip: string, type: Types.AddressType };

export type GetPaymentsByTaxYearInterviewIdQueryVariables = Types.Exact<{
  taxYearInterviewId: Types.Scalars['String'];
  includeDeleted?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type GetPaymentsByTaxYearInterviewIdQuery = { __typename?: 'Query', paymentsByTaxYearInterviewId: Array<{ __typename?: 'PaymentsEntity', id: string, referralFee?: number | null, preparerFee?: number | null, discountApplied?: number | null, totalDollarAmount?: number | null, paymentProcessorFee?: number | null, entityId?: string | null, taskId?: string | null, taxYearInterviewId?: string | null, paymentProcessorId?: string | null, paidOffline?: boolean | null, completedAt?: any | null, deletedAt?: any | null, status?: string | null, requestAt?: any | null, promisedAt?: any | null, paymentIntentId?: string | null, createAt?: any | null, updateAt?: any | null, Invoices?: Array<{ __typename?: 'InvoicesEntity', id: string, description: string, priceEach: number, quantity: number, paymentId: string, createAt: any, updateAt: any }> | null, FirmAccount?: { __typename?: 'FirmAccountEntity', id: string, name?: string | null, BusinessInformation?: { __typename?: 'BusinessInformationEntity', id?: string | null, Address?: Array<{ __typename?: 'AddressEntity', id: string, lineOne: string, lineTwo?: string | null, city: string, state: string, zip: string, type: Types.AddressType }> | null, Phones?: Array<{ __typename?: 'PhonesEntity', id: string, value: string, type: Types.PhoneType }> | null } | null, Users?: { __typename?: 'UserEntity', UserInformation?: { __typename?: 'UserInformationEntity', firstName: string, lastName: string, Address?: Array<{ __typename?: 'AddressEntity', id: string, lineOne: string, lineTwo?: string | null, city: string, state: string, zip: string, type: Types.AddressType }> | null, Phones?: Array<{ __typename?: 'PhonesEntity', id: string, value: string, type: Types.PhoneType }> | null } | null } | null, CustomLayout?: { __typename?: 'CustomLayoutEntity', logo?: string | null } | null } | null, Entity?: { __typename?: 'Entity', Users?: { __typename?: 'UserEntity', UserInformation?: { __typename?: 'UserInformationEntity', firstName: string, lastName: string, Address?: Array<{ __typename?: 'AddressEntity', id: string, lineOne: string, lineTwo?: string | null, city: string, state: string, zip: string, type: Types.AddressType }> | null, Phones?: Array<{ __typename?: 'PhonesEntity', id: string, value: string, type: Types.PhoneType }> | null } | null } | null } | null }> };

export type GetFirmLogoQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetFirmLogoQuery = { __typename?: 'Query', GetFirmLogo?: { __typename?: 'FirmLogoEntity', base64: string, width: number, height: number } | null };

export const PaymentPhoneFragmentDoc = gql`
    fragment PaymentPhone on PhonesEntity {
  id
  value
  type
}
    `;
export const PaymentAddressFragmentDoc = gql`
    fragment PaymentAddress on AddressEntity {
  id
  lineOne
  lineTwo
  city
  state
  zip
  type
}
    `;
export const GetPaymentsByTaxYearInterviewIdDocument = gql`
    query GetPaymentsByTaxYearInterviewId($taxYearInterviewId: String!, $includeDeleted: Boolean) {
  paymentsByTaxYearInterviewId(
    taxYearInterviewId: $taxYearInterviewId
    includeDeleted: $includeDeleted
  ) {
    id
    referralFee
    preparerFee
    discountApplied
    totalDollarAmount
    paymentProcessorFee
    entityId
    taskId
    taxYearInterviewId
    paymentProcessorId
    paidOffline
    completedAt
    deletedAt
    status
    requestAt
    promisedAt
    paymentIntentId
    createAt
    updateAt
    Invoices {
      id
      description
      priceEach
      quantity
      paymentId
      createAt
      updateAt
    }
    FirmAccount {
      id
      name
      BusinessInformation {
        id
        Address {
          ...PaymentAddress
        }
        Phones {
          ...PaymentPhone
        }
      }
      Users {
        UserInformation {
          firstName
          lastName
          Address {
            ...PaymentAddress
          }
          Phones {
            ...PaymentPhone
          }
        }
      }
      CustomLayout {
        logo
      }
    }
    Entity {
      Users {
        UserInformation {
          firstName
          lastName
          Address {
            ...PaymentAddress
          }
          Phones {
            ...PaymentPhone
          }
        }
      }
    }
  }
}
    ${PaymentAddressFragmentDoc}
${PaymentPhoneFragmentDoc}`;

/**
 * __useGetPaymentsByTaxYearInterviewIdQuery__
 *
 * To run a query within a React component, call `useGetPaymentsByTaxYearInterviewIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentsByTaxYearInterviewIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentsByTaxYearInterviewIdQuery({
 *   variables: {
 *      taxYearInterviewId: // value for 'taxYearInterviewId'
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useGetPaymentsByTaxYearInterviewIdQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentsByTaxYearInterviewIdQuery, GetPaymentsByTaxYearInterviewIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentsByTaxYearInterviewIdQuery, GetPaymentsByTaxYearInterviewIdQueryVariables>(GetPaymentsByTaxYearInterviewIdDocument, options);
      }
export function useGetPaymentsByTaxYearInterviewIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentsByTaxYearInterviewIdQuery, GetPaymentsByTaxYearInterviewIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentsByTaxYearInterviewIdQuery, GetPaymentsByTaxYearInterviewIdQueryVariables>(GetPaymentsByTaxYearInterviewIdDocument, options);
        }
export type GetPaymentsByTaxYearInterviewIdQueryHookResult = ReturnType<typeof useGetPaymentsByTaxYearInterviewIdQuery>;
export type GetPaymentsByTaxYearInterviewIdLazyQueryHookResult = ReturnType<typeof useGetPaymentsByTaxYearInterviewIdLazyQuery>;
export type GetPaymentsByTaxYearInterviewIdQueryResult = Apollo.QueryResult<GetPaymentsByTaxYearInterviewIdQuery, GetPaymentsByTaxYearInterviewIdQueryVariables>;
export const GetFirmLogoDocument = gql`
    query GetFirmLogo($id: String!) {
  GetFirmLogo(id: $id) {
    base64
    width
    height
  }
}
    `;

/**
 * __useGetFirmLogoQuery__
 *
 * To run a query within a React component, call `useGetFirmLogoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFirmLogoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFirmLogoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFirmLogoQuery(baseOptions: Apollo.QueryHookOptions<GetFirmLogoQuery, GetFirmLogoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFirmLogoQuery, GetFirmLogoQueryVariables>(GetFirmLogoDocument, options);
      }
export function useGetFirmLogoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFirmLogoQuery, GetFirmLogoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFirmLogoQuery, GetFirmLogoQueryVariables>(GetFirmLogoDocument, options);
        }
export type GetFirmLogoQueryHookResult = ReturnType<typeof useGetFirmLogoQuery>;
export type GetFirmLogoLazyQueryHookResult = ReturnType<typeof useGetFirmLogoLazyQuery>;
export type GetFirmLogoQueryResult = Apollo.QueryResult<GetFirmLogoQuery, GetFirmLogoQueryVariables>;
export const namedOperations = {
  Query: {
    GetPaymentsByTaxYearInterviewId: 'GetPaymentsByTaxYearInterviewId',
    GetFirmLogo: 'GetFirmLogo'
  },
  Fragment: {
    PaymentPhone: 'PaymentPhone',
    PaymentAddress: 'PaymentAddress'
  }
}